




















import Vue, { PropOptions } from 'vue';
import {ISelectOption as iso} from '@/class/models/typed/wild';
import ClickOutside from 'vue-click-outside';
export type IOption = iso;

const NOINITIALVALUE = 'NoInitialValue';

export default Vue.extend({
  name: 'SelectBox',
  props: {
    initialValue: {
      type: Number,
      default: 0,
    },
    options: Array as PropOptions<iso[]>,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectValue: 0,
      selectorshow: false,
    };
  },
  mounted() {
    let value = this.initialValue;
    // 初期値がない場合
    if (value === 0 && this.options.length >= 0 ) {
      value = this.options[0].value;
    }
    this.selectValue = value;
  },
  directives: {
      ClickOutside,
  },
  watch: {
    selectValue() {
      this.$emit('change', this.selectValue);
    },
    initialValue() {
      this.selectValue = this.initialValue;
    },
  },
  methods: {
    closeSelect() {
      this.selectorshow = false;
    },
  },
});
